<template>
  <v-row
    align="center"
    justify="space-around"
    class="ma-0 pa-0 flex-no-wrap"
  >
    <material-card
      v-if="start === -1"
      :height="height"
      :value="{
        title: 'New Material',
        status: $enums.Status.PUBLISHED.key,
        renders_order: [],
        renders: [],
      }"
      :selectable="false"
      :downloadable="false"
      :background-color="backgroundColor"
      :bottom-size="cardBottomSize"
      @click:image="$emit('click:new-item')"
      @click:open="$emit('click:new-item')"
      @click="$emit('click:new-item')"
      @click:download="$emit('click:new-item')"
    >
      <template #image>
        <v-avatar
          height="100%"
          width="100%"
          class="dashed--border white--border pa-2"
          @click="$emit('click:new-item')"
        >
          <div class="display-3 primary--text text-hyphens overflow-hidden">
              Create new material
          </div>
        </v-avatar>
      </template>
    </material-card>

    <material-card
      v-for="item in itemsSlice"
      :key="item.id"
      :height="height"
      :value="item"
      :background-color="backgroundColor"
      :bottom-size="cardBottomSize"
      :selected="selected.includes(item.id)"
      :selectable="selectable"
      :downloadable="false"
      @click:image="onClickImage(item)"
      @click:download="$emit('click:download', item)"
      @click:favorite="$emit('click:favorite', item)"
      @click="$emit('click:item', item)"
      @click:open="$emit('click:open', item)"
      v-intersect="{
        handler: onIntersectItem(item),
        options: {
          threshold: [0.5]
        }
      }"
    >
      <template #hover="{ hover }"><slot name="item-hover" :hover="hover" :item="item"></slot></template>
    </material-card>

    <app-card
      v-for="item in emtyItems"
      :key="item"
      :height="height"
      :width="itemWidth"
      color="transparent"
    >
    </app-card>
  </v-row>
</template>

<script>
  import MaterialCard from "./MaterialCard";
  import { subject } from '@casl/ability';

  export default {
    name: "MaterialListViewRow",

    components: {
      MaterialCard,
    },

    props: {
      backgroundColor: {
        type: String,
      },
      height: {
        type: Number,
        default: 200,
      },
      allItems: {
        type: Array,
        default: () => [],
      },
      start: {
        type: Number,
        default: 0,
      },
      amount: {
        type: Number,
        default: 4,
      },
      cardBottomSize: {
        type: Number,
        default: 70,
      },
      selected: {
        type: Array,
        default: () => [],
      },
      selectable: {
        type: Boolean,
        default: true,
      },
    },

    computed: {
      itemsSlice() {
        let { start, amount, allItems } = this;
        return allItems.slice(Math.max(start, 0), start + amount);
      },

      emtyItems() {
        let { amount, itemsSlice } = this;
        return amount - itemsSlice.length;
      },

      itemWidth() {
        return this.height - this.cardBottomSize;
      },
    },

    methods: {
      onIntersectItem(item) {
        this.$emit('show:material', item);
      },

      onClickImage(item) {
        if (this.selectable) return;
        this.$emit('click:image', item)
      },

      subjectMaterial(item) {
        return subject(this.$enums.Entity.MATERIAL, item);
      },

      isMaterialFavoriteActionable(item) {
        let subj = this.subjectMaterial(item);
        return this.$can('make_favorite', subj) || this.$can('unmake_favorite', subj);
      }
    }
  }
</script>
